

document.addEventListener('DOMContentLoaded', function() {
    // Desktop menu sub menu
    const menuItems = document.querySelectorAll('.mainNavigation li.hasChildren');

    menuItems.forEach((menuItem) => {
        menuItem.addEventListener('click', (event) => {
            const target = event.target; // Element that triggered the click
            const isAnchor = target.tagName === 'A'; // Check if the clicked element is an anchor tag
    
            // Prevent default for the parent menu item's <a> tag
            if (isAnchor && menuItem.contains(target) && menuItem.querySelector('ul').contains(target) === false) {
                event.preventDefault(); // Stop navigation for the menuItem's own <a> tag
            }

            // Toggle open/close state
            if (menuItem.classList.contains('open')) {
                menuItem.classList.remove('open');
            }
            else {
                menuItems.forEach((item) => item.classList.remove('open'));
                menuItem.classList.add('open');
            }
        });
    });

    // Close menu when clicking outside
    document.addEventListener('click', (event) => {
        // Check if the click is outside of any menu item
        if (![...menuItems].some(menuItem => menuItem.contains(event.target))) {
            menuItems.forEach((menuItem) => menuItem.classList.remove('open'));
        }
    });

    // Mobile menu sub menu
    const menuItemsMobile = document.querySelectorAll('.mainNavigationMobile li.hasChildren');

    menuItemsMobile.forEach((menuItem) => {
        menuItem.addEventListener('click', (event) => {
            const target = event.target; // Element that triggered the click
            const isAnchor = target.tagName === 'A'; // Check if the clicked element is an anchor tag
    
            // Prevent default for the parent menu item's <a> tag
            if (isAnchor && menuItem.contains(target) && menuItem.querySelector('ul').contains(target) === false) {
                event.preventDefault(); // Stop navigation for the menuItem's own <a> tag
            }

            if (menuItem.classList.contains('closed')) {
                menuItem.classList.remove('closed');
            }
            else {
                menuItemsMobile.forEach((item) => item.classList.remove('closed'));
                menuItem.classList.add('closed');
            }
        });
    });

    // Mobile menu
    const menuIcon = document.querySelector('.menuIcon');
    const menuOpen = document.querySelector('.openMenu');
    const menuClose = document.querySelector('.closeMenu');
    const mobileNavigation = document.querySelector('.mainNavigationMobile');
    const body = document.body;
    const header = document.querySelector('.header');
    const menuToggle = document.querySelector('.menuToggle');

    if (!menuIcon || !menuOpen || !menuClose || !mobileNavigation || !menuToggle) {
        console.error('One or more elements not found:', { menuIcon, menuOpen, menuClose, mainNavigation, menuToggle });
        return;
    }

    menuIcon.addEventListener('click', () => {
        const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';

        mobileNavigation.classList.toggle('show');
        menuOpen.classList.toggle('hidden');
        menuClose.classList.toggle('hidden');
        body.classList.toggle('menuActive');

        menuToggle.setAttribute('aria-expanded', !isExpanded);
    });
 });